module.exports = __webpack_public_path__ + "img/icon_business_grey.829d2005.svg";